/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface IQuantity
 */
export interface IQuantity {
    /**
     * 
     * @type {string}
     * @memberof IQuantity
     */
    $type?: IQuantityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IQuantity
     */
    unit?: string;
    /**
     * 
     * @type {number}
     * @memberof IQuantity
     */
    value?: number;
}


/**
 * @export
 */
export const IQuantityTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type IQuantityTypeEnum = typeof IQuantityTypeEnum[keyof typeof IQuantityTypeEnum];


/**
 * Check if a given object implements the IQuantity interface.
 */
export function instanceOfIQuantity(value?: unknown): value is IQuantity {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(IQuantityTypeEnum)[0];
}

export function IQuantityFromJSON(json: any): IQuantity {
    return IQuantityFromJSONTyped(json, false);
}

export function IQuantityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQuantity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function IQuantityToJSON(value?: IQuantity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value.$type,
        'unit': value.unit,
        'value': value.value,
    });
}

